export const HUMAN_FULL_DATE_FORMAT = 'MMMM Do YYYY, h:mm A';
